import queryString from "query-string";
import { useLocation } from "react-router-dom";

const useQueryParams = () => {
  const { search } = useLocation();
  return queryString.parse(search);
};

export default useQueryParams;
